import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70cddea8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=70cddea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cddea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cddea8')) {
      api.createRecord('70cddea8', component.options)
    } else {
      api.reload('70cddea8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70cddea8&scoped=true&", function () {
      api.rerender('70cddea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/text_ellipsis/index.vue"
export default component.exports